import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

// Create the context
const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
    const [exploreNow, setExploreNow] = useState(false);
    const [navbarExpanded, setNavbarExpanded] = useState(false);
    const [selectedIndustryProd, setSelectedIndustryProd] = useState("")
    const [showMegaMenu, setShowMegaMenu] = useState({
        services: false,
        hireTeam: false,
    });
    const [ipAddress, setIpAddress] = useState("");

    // Define the context value
    const contextValue = {
        exploreNow,
        setExploreNow,
        showMegaMenu,
        setShowMegaMenu,
        navbarExpanded,
        setNavbarExpanded,
        selectedIndustryProd,
        setSelectedIndustryProd,
        ipAddress,
        setIpAddress,
    };
    useEffect(() => {
        const fetchIP = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json");
                setIpAddress(response.data.ip);
            } catch (error) {
                console.error("Error fetching IP address or blog data:", error);
            }
        };

        fetchIP();
    }, []); // Dependency array is empty, so this effect runs only once after the initial render
    return (
        <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
    );
};

// Custom hook to use the context
export const useAppContext = () => {
    return useContext(AppContext);
};